import React, { createContext, useContext, useState, useCallback } from 'react';
import CustomAlert from '../components/CustomAlert';

const AlertContext = createContext();

export const useAlert = () => {
    return useContext(AlertContext);
};

export const AlertProvider = ({ children }) => {
    const [alert, setAlertState] = useState({ show: false, type: '', message: '' });

    const setAlert = useCallback(({ type, message }) => {
        setAlertState({ show: true, type, message });
    }, []);

    const closeAlert = useCallback(() => {
        setAlertState({ show: false, type: '', message: '' });
    }, []);

    return (
        <AlertContext.Provider value={setAlert}>
            {children}
            {alert.show && (
                <CustomAlert
                    type={alert.type}
                    message={alert.message}
                    onClose={closeAlert}
                />
            )}
        </AlertContext.Provider>
    );
};
